// Injected at runtime by /api/runtime-config.js (backend, server.py); absent → standalone.
const runtime = window.__RGPD_CONFIG__ || {};

export const isEmbedded = runtime.integrationMode === "embedded";

const parentOrigins = runtime.embedParentOrigins || [];

export function resolvePortalOrigin() {
  let origin = "";
  try {
    origin = new URL(document.referrer).origin;
  } catch {
    origin = "";
  }
  if (parentOrigins.includes(origin)) return origin;
  return parentOrigins.length === 1 ? parentOrigins[0] : null;
}

// Moovapps relay protocol (UserInfoController): the portal page answers from the same origin as its iframe src.
export function requestFromParent(type, responseType, portalOrigin, timeoutMs = 10000) {
  return new Promise((resolve, reject) => {
    const requestId = Math.random().toString(36).slice(2);
    const timer = setTimeout(() => {
      window.removeEventListener("message", onMsg);
      reject(new Error("Pas de réponse du portail"));
    }, timeoutMs);
    function onMsg(ev) {
      if (ev.source !== window.parent) return;
      if (ev.origin !== portalOrigin) return;
      if (!ev.data || ev.data.type !== responseType || ev.data.requestId !== requestId) return;
      clearTimeout(timer);
      window.removeEventListener("message", onMsg);
      ev.data.error ? reject(new Error(ev.data.error)) : resolve(ev.data);
    }
    window.addEventListener("message", onMsg);
    window.parent.postMessage({ type, requestId }, portalOrigin);
  });
}

// Resolves to { assertion, expiration, user }; only `assertion` (signed) is sent to the backend.
export const requestUserInfoFromParent = (portalOrigin) =>
  requestFromParent("dco-userinfo-request", "dco-userinfo-response", portalOrigin);
